import { Action } from '@ngrx/store';
import { DebtAnalysisWidgetConfiguration } from '../models/debt-analysis-widget-configuration.model';

export const LOAD_ALL = '[Debt Analysis Widget Configuration] Load All';
export const LOAD_ALL_COMPLETE = '[Debt Analysis Widget Configuration] Load All Complete';
export const LOAD_ALL_ERROR = '[Debt Analysis Widget Configuration] Load All Error';

export class DebtAnalysisWidgetConfigActionPayload {
  constructor(public widgetConfigurationId: number, public config?: DebtAnalysisWidgetConfiguration, public error?: any) { }
}

export class DebtAnalysisWidgetConfigsActionPayload {
  constructor(public configs?: Array<DebtAnalysisWidgetConfiguration>, public error?: any) { }
}

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor(public payload: DebtAnalysisWidgetConfigsActionPayload) { }
}

export class LoadAllComplete implements Action {
  readonly type = LOAD_ALL_COMPLETE;
  constructor(public payload: DebtAnalysisWidgetConfigsActionPayload) { }
}

export class LoadAllError implements Action {
  readonly type = LOAD_ALL_ERROR;
  constructor(public payload: DebtAnalysisWidgetConfigsActionPayload) { }
}


export type Actions =
  LoadAll |
  LoadAllError |
  LoadAllComplete;
